var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPaintMouth = function SvgPaintMouth(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 53,
    height: 29,
    viewBox: "0 0 1.98 1.07",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.71.09c.13-.03.46.01.61-.04.05-.01.35-.02.39-.01.13.05.25.26.23.42-.05.35-.45.5-.74.55-.34.05-.48.04-.86-.06C.07.88-.21.03.41.09.5.1.6.11.71.09zm.12.14c.24.22.12.21.34 0 .08.09.42.24.43.26C1.43.7 1.14.9.86.83.66.77.51.75.39.59.38.58.81.24.83.23z",
    fill: "#000",
    stroke: "#000",
    strokeWidth: 0.07,
    strokeMiterlimit: 22.9256
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M.83.23c.24.22.12.21.34 0 .08.09.42.24.43.26C1.43.7 1.14.9.86.83.66.77.51.75.39.59.38.58.81.24.83.23z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.11,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256
  })));
};

export default SvgPaintMouth;